import React from 'react'
import CircularImage from './CircularImage';
import { replaceUrlForHttps } from '../utils';

const defaultImg = require('../img/icons/avatar.png');

const Avatar = ({ src, ...props }) => (
    <CircularImage 
        src={ src ? replaceUrlForHttps(src) : defaultImg} 
        {...props}
    />
);

export default Avatar;


// WEBPACK FOOTER //
// ./src/components/Avatar.js